module.exports = __webpack_public_path__ + "img/infp.e855d8fc.png";